import { RegisterTokenData, UpdateTokenData } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { isIOS } from "react-device-detect";

export class PushNotificationsService extends BaseService {
    registerDeviceToken(
        memberId: string,
        token: RegisterTokenData["token"],
        deviceId: RegisterTokenData["deviceId"],
    ) {
        return this.ngCall(
            "post",
            appConstants.ngEndpoints.registerDeviceToken(memberId),
            {
                deviceToken: token,
                appName: "LTD Media",
                platform: isIOS ? "ios" : "android",
                language: "EN",
                appType: 1,
                deviceId: deviceId,
            },
        );
    }

    updateDeviceToken(
        memberId: string,
        oldToken: UpdateTokenData["oldToken"],
        newToken: UpdateTokenData["newToken"],
        deviceId: RegisterTokenData["deviceId"],
    ) {
        return this.ngCall(
            "put",
            appConstants.ngEndpoints.updateDeviceToken(memberId),
            {
                oldDeviceToken: oldToken,
                newDeviceToken: newToken,
                appName: "LTD Media",
                platform: isIOS ? "ios" : "android",
                language: "EN",
                deviceId: deviceId,
                appType: 1,
            },
        );
    }
}
